import API from 'vuex-requests/src/store/backends/API'
import axios from 'axios'

export default class InvoiceGuruBackend extends API {
  constructor (name = 'invoiceguru', store, options = {}) {
    super(name, store, options)
    this.store = store
    this.baseUrl = process.env.INVOICEGURU_API_ROOT
    this.headers = {
      'Content-Type': 'application/json'
    }
  }
  resources () {
    return {
      invoices: 'invoices/',
      statements: 'statements/',
      upgrade: 'invoices/upgrade/',
      invoiceSettings: '/invoices/settings/',
      transactions: 'transactions/',
      overdue: 'invoices/reports/overdue/',
      actions: 'action/'
    }
  }
  getOptions () {
    let token = this.store.getters.token
    let headers = {
      'authorization': `bearer ${token}`,
      'content-type': 'application/json'
    }
    return { headers: headers }
  }
  performAction (resource, action, pk, params) {
    let options = this.getOptions()
    let url = `${this.baseUrl}/${resource}/${pk}/actions/${action}/`
    return axios.post(url, params, options)
  }
  sendInvoice (invoiceId, emails, sms) {
    let options = this.getOptions()
    let data = {
      'to_email': emails
    }
    if (sms) {
      data['to_phone'] = sms
    }
    let url = `${this.baseUrl}/invoices/${invoiceId}/send/`
    return axios.post(url, data, options)
  }
  validateInvoice (invoiceId, emails, sms) {
    let options = this.getOptions()
    let url = `${this.baseUrl}/invoices/${invoiceId}/validations/`
    return axios.get(url, options)
  }
  quickCreate (practitionerId, clientId, appointmentIds, context) {
    let baseurl = process.env.INVOICEGURU_API_ROOT
    appointmentIds = appointmentIds.join(',')
    let qs = `practitioner_id=${practitionerId}&appointment_ids=${appointmentIds}&client_id=${clientId}`
    let url = `${baseurl}/invoices/construct/?${qs}`
    let token = this.store.getters.token
    let headers = {
      'authorization': `bearer ${token}`,
      'content-type': 'application/json'
    }
    let options = { headers: headers }
    let data = JSON.stringify({
      context: context
    })
    return axios.post(url, data, options)
  }
  markAsPaid (invoice) {
    let baseurl = process.env.INVOICEGURU_API_ROOT
    let url = `${baseurl}/invoices/${invoice.id}/paid/`
    let token = this.store.getters.token
    let headers = {
      'authorization': `bearer ${token}`
    }
    let options = { headers: headers }
    return axios.post(url, {}, options)
  }
}



// WEBPACK FOOTER //
// ./src/store/backends/invoiceguru.js